import store from "@/store";
import names from  "@/modules/recording/routers/names"

export function getInstMenu() {
    /**
     * Функция которая возвращает нижнее боковое меню инстанса
     * @return {Array} - списко всех подмодулей инстанса, отображаемых в левом нижнем меню
     */
    let menu = []

    if (store.getters['urls/getAllowed']( 'singlerecording', 'admin|events-list', 'list'))
        menu.push({title: 'Администрирование', icon: 'settings_applications', router: names.ADMIN._BASE, name: 'Admin',})
    if (store.getters['urls/getAllowed']( 'singlerecording', 'event|admin|events-list', 'list'))
        menu.push({title: 'Управление записью', icon: 'view_quilt', router: names.ADMINEVENTS._BASE, name: 'AdminEvents',})
    if (store.getters['urls/getAllowed']( 'singlerecording', 'events-list', 'list'))
        menu.push({title: 'Выбор мероприятия', icon: 'assured_workload', router: names.BASE, name: 'Recording',})
    return menu
}

export function getInstNameByRouterName(router) {
    /**
     * Функция которая возвращает нижнее боковое меню инстанса
     * @return {Array} - списко всех подмодулей инстанса, отображаемых в левом нижнем меню
     */
    return getInstMenu().find(el => {
        return router === el.router
    }).name
}
